import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPostcard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPostcard1"><Path d="M5.5 8.5L10.5 8.5M5.5 11.5L7.5 11.5M2.5 4.5H21.5V19.5H2.5V4.5ZM14.5 8.5L18.5 8.5V13.5L14.5 13.5V8.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPostcard1;
